import { FC, PropsWithChildren } from "react";
import { Navigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";

import { RootState } from "@/utils/store";

const CheckIfTeamExists: FC<PropsWithChildren> = ({ children }) => {
  const { teamId } = useParams();

  const teams = useSelector(
    (rootState: RootState) => rootState.auth.user!.teams
  );

  const teamExists =
    teamId &&
    (teamId === "all" || teams.map((t) => t.id.toString()).includes(teamId));

  if (!teamExists) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default CheckIfTeamExists;
